// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"subpage-module--outer-container--m1gFd","subpageWrap":"subpage-module--subpage-wrap--3ly_2","subpage":"subpage-module--subpage--2HEtP"};